import { Controller } from "@hotwired/stimulus"
import { get, destroy } from '@rails/request.js'

// Connects to data-controller="turbo"
export default class extends Controller {
  initialize() {
    this.element.setAttribute('data-action', 'click->turbo#click')
  }

  async click(e) {
    e.preventDefault()
    this.url = this.element.getAttribute('href')

    document.dispatchEvent(new CustomEvent('spinner:show'))

    try {
      if (this.element.dataset.method === 'delete') {
        await destroy(this.url, {
          responseKind: 'turbo-stream'
        })
      } else {
        await get(this.url, {
          responseKind: 'turbo-stream'
        })
      }
    } finally {
      document.dispatchEvent(new CustomEvent('spinner:hide'))
    }
  }
}
